'use strict';
module.exports = function hide(element) {
	element.style.display = 'none';
};
